import React, { useState } from "react";
import * as S from "./SectionCard.style";
import CardDetail from "../CardDetail/CardDetail";
import CollapseItem from "../CollapseItem/CollapseItem";

const SectionCard = ({
  title,
  align,
  subtext1,
  subtext2,
  subtext3,
  cardDetailBox,
  id,
  itens,
  botaoMaisInfo,
  width,
  image
}) => {
  const [currentItem, setCurrentItem] = useState(-1);
  const [continuar, setContinuar] = useState(false);

  const handleClick = () => {
    setContinuar(!continuar);
  };
  return (
    <S.Container id={id} align={align} >
      <S.SectionTitle style={{width: width}}>
        <S.Title>{title}</S.Title>
        <S.Title >
          <div>
            {subtext1 && (
              <S.TextStyled variant="body02-sm">{subtext1}</S.TextStyled>
            )}
            {subtext2 && (
              <S.TextStyled variant="body02-sm">{subtext2}</S.TextStyled>
            )}
            {subtext3 && (
              <S.TextStyled variant="body02-sm">{subtext3}</S.TextStyled>
            )}
          </div>
        </S.Title>
      </S.SectionTitle>
      {(itens || cardDetailBox || image) && (
        <S.SectionText>
        {cardDetailBox && (
          <S.Box>
            <S.CardsContainer>
              <CardDetail
                title="CAIXA Consorcio"
                link={"https://www.caixaconsorcio.com.br"}
              />
            </S.CardsContainer>
          </S.Box>
        )
        
        }

        {image && (
          <S.ImageContainer src={image} />
        ) }
        {itens &&
          itens.map(
            (item, index) =>
              (item.showDefault || continuar) && (
                <CollapseItem
                  key={index}
                  question={item.question}
                  answers={item.answers}
                  selectedItem={currentItem}
                  onChange={(item) => setCurrentItem(item)}
                  item={index}
                />
              )
          )}
        {botaoMaisInfo && (
          <S.ButtonContainer>
            {continuar ? (
              <S.ButtonStyled
                onClick={() => {
                  handleClick();
                }}
              >
                Menos detalhes
              </S.ButtonStyled>
            ) : (
              <S.ButtonStyled
                onClick={() => {
                  handleClick();
                }}
              >
                Mais detalhes
              </S.ButtonStyled>
            )}
          </S.ButtonContainer>
        )}
      </S.SectionText>
      )}
      
    </S.Container>
  );
};

export default SectionCard;
